import { booleanAttribute, Directive, input } from '@angular/core';
import { V3ScrollableContentListController } from './scrollable-content-list.controller';
import { Pv2PlayButtonPosition } from '../../content';

/**
 * Extends the Scrollable Content List with standard settings and css classes for vertacal style playable lists.
 */
@Directive()
export class V3ContentVerticalListController extends V3ScrollableContentListController {
  public readonly eventSource = input.required<string>();
  public playButtonPosition = input<Pv2PlayButtonPosition>('none');
  public shrinkOnMobile = input(true, { transform: booleanAttribute });
  public displayDurations = input(true, { transform: booleanAttribute });
  public displayTagLines = input(true, { transform: booleanAttribute });
  public displayThirdLine = input(true, { transform: booleanAttribute });

  override buildWrapperKlasses(): string[] {
    const klasses: string[] = [];
    const imageSize = this.imageSize();
    if (imageSize === 'small') {
      klasses.push('compact-list');
    }
    const playButtonPosition = this.playButtonPosition();
    if (playButtonPosition !== 'none') {
      klasses.push('play-button-position-' + playButtonPosition);
    }
    if (this.shrinkOnMobile()) {
      klasses.push('shrink-on-mobile');
    }
    return klasses;
  }
}
